import React from 'react';
import T from 'i18n-react';
import TextField from '../../../core/FormField/TextField';
import { ProgressButton } from '../../../core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  divider: {
    width: '100%',
    maxWidth: 300,
    margin: theme.spacing(0, 'auto', 4),
  },
  title: {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 'bold',
    margin: theme.spacing(0, 'auto', 4),
  },
  textField: {
    maxWidth: 300,
    margin: theme.spacing(0, 'auto', 2.5),
  },
  buttonContainer: {
    margin: theme.spacing(0, 'auto', 2.5),
    width: '100%',
    maxWidth: 300,
    '& > *': {
      width: '100%',
      maxWidth: 300,
    },
  },
  button: {
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
}));

const EmailLoginForm = () => {
  const classes = useStyles();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [isRequesting] = React.useState(false);

  return (
    <div className={classes.container}>
      <Divider className={classes.divider} />
      <Typography className={classes.title}>
        {T.translate('user.login.title')}
      </Typography>
      <TextField
        label={T.translate('email')}
        type="email"
        variant="outlined"
        fullWidth
        className={classes.textField}
        disabled={isRequesting}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        label={T.translate('user.signup.password')}
        type="password"
        variant="outlined"
        fullWidth
        className={classes.textField}
        disabled={isRequesting}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <div className={classes.buttonContainer}>
        <ProgressButton
          color="primary"
          variant="contained"
          fullWidth
          className={classes.button}
          disabled={isRequesting}
          progress={isRequesting}
        >
          {T.translate('login')}
        </ProgressButton>
      </div>
    </div>
  );
};

export default EmailLoginForm;
